import React, { useEffect, useRef, useState } from "react";
import { message } from "antd";

import BoardColumnCollapsed from "./BoardColumnCollapsed";
import CreateBoardForm from "./CreateBoardForm";
import BoardColumn from "./BoardColumn";

import PatientDetails from "./PatientDetails";
import { controller } from "./controller";

export default function BoardsContainer({ boards, boardsContainer, setCreateNewBoard, createNewBoard, setSelectedBoardStatistics, onBoardCreated }) {
  const [collapasedBoards, setCollapsedBoards] = useState([]);
  const [clickedPatientId, setClickedPatientId] = useState(null);

  const [deleting, setDeleting] = useState(false);
  const modalRef = useRef(null);

  // Close the modal by clicking outside
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (modalRef.current && !modalRef.current.contains(event.target)) {
  //       setClickedPatientId(null);
  //     }
  //   }

  //   if (clickedPatientId) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [clickedPatientId]);

  const handleDeleteBoard = async (boardId) => {
    try {
      setDeleting(true);
      await controller.removeGroup(boardId);
      message.success("The group was deleted successfully");
      onBoardCreated()
      setDeleting(false);
    } catch (err) {
      message.error("Something went wrong while deleting group");
      console.error(err);
    }
  };

  return (
    // Wrap everything in a relatively positioned parent
    <div style={{ position: "relative", width: "100%", height: "640px" }}>
      {/* Scrollable container */}
      <div
        style={{
          width: "100%",
          height: "114%",
          display: "flex",
          alignItems: "center",
          gap: 30,
          paddingInline: 10,
          overflowX: "auto",
          position: "relative", // Keep this to maintain board positions
          paddingBottom: 20,
        }}
        ref={boardsContainer}
        className="custom-scroll"
        id="modalContainer"
      >
        {boards &&
          boards.map((board) => {
            if (board.type === "manual" && !board.real_manual) return; // Filter out failed and processed boards

            return collapasedBoards.includes(board.id) ? (
              <BoardColumnCollapsed key={board.id} setCollapsedBoards={setCollapsedBoards} board={board} />
            ) : (
              <BoardColumn
                setSelectedBoardStatistics={setSelectedBoardStatistics}
                setClickedPatientId={setClickedPatientId}
                setCollapsedBoards={setCollapsedBoards}
                onDelete={handleDeleteBoard}
                key={board.key}
                board={board}
              />
            );
          })}

        {createNewBoard && <CreateBoardForm setCreateNewBoard={setCreateNewBoard} onBoardCreated={onBoardCreated}/>}
      </div>

      {/* Modal as sibling, but inside same parent */}
      {clickedPatientId && <PatientDetails modalRef={modalRef} setClickedPatientId={setClickedPatientId} clickedPatientId={clickedPatientId} />}
    </div>
  );
}
